// App Imports
import { LIST_BY_PARENT_DONE, LIST_BY_PARENT_REQUEST, LIST_BY_PARENT_RESET, LIST_BY_PARENT_RESPONSE } from '../actions/types'

// List

// Initial State
const deliveriesBoyByParentInitialState = {
  isLoading: false,
  list: []
}

// State
const listByParent = (state = deliveriesBoyByParentInitialState, action) => {
  switch (action.type) {
    case LIST_BY_PARENT_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading
      }

    case LIST_BY_PARENT_RESPONSE:
      return {
        ...state,
        list: action.list
      }

    case LIST_BY_PARENT_DONE:
      return {
        ...state,
        isLoading: false
      }

    case LIST_BY_PARENT_RESET:
      return { ...deliveriesBoyByParentInitialState }

    default:
      return state
  }
}
export default listByParent